<template>
  <div class="info-vt info-vt-qid">
    <div class="top-info-vt-qid">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 3H8C7.44772 3 7 3.44772 7 4V5C7 5.55228 7.44772 6 8 6H9C9.55228 6 10 6.44772 10 7V10.6105C10 10.861 9.90598 11.1024 9.73653 11.2869L7.26347 13.9798C7.09402 14.1643 7 14.4057 7 14.6562V15C7 15.5523 7.44772 16 8 16H16C16.5523 16 17 15.5523 17 15V14.6562C17 14.4057 16.906 14.1643 16.7365 13.9798L14.2635 11.2869C14.094 11.1024 14 10.861 14 10.6105V7C14 6.44772 14.4477 6 15 6H16C16.5523 6 17 5.55228 17 5V4C17 3.44772 16.5523 3 16 3Z" stroke="#526C82" stroke-opacity="0.8" stroke-width="2"/>
        <path d="M12 17V23" stroke="#526C82" stroke-opacity="0.8" stroke-width="2"/>
      </svg>
      <p v-html="desc"></p>
    </div>
    <img :src="imgEn" alt="" class="img-en">
    <img :src="imgAr" alt="" class="img-ar">
  </div>
</template>

<script>
export default {
  name: 'BaseIstimara',
  props: ['desc', 'img-en', 'img-ar']
}
</script>
